import type { HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';

type TimelineProps = PropsWithChildren & HTMLAttributes<HTMLDivElement>;

export const Timeline = ( { children, className, ...divAttrs }: TimelineProps ) => {

  return (
    <div
      className={ cn( 'flex flex-col', className ) }
      { ...divAttrs }
    >
      { children }
    </div>
  )
}
Timeline.displayName = 'Timeline';
